import React from 'react';
import OutboundLink from '../../../../atoms/OutboundLink';
import './RecaptchaTermsNotice.less';
function RecaptchaTermsNotice() {
  return /*#__PURE__*/React.createElement("div", {
    className: "recaptcha-terms-notice"
  }, /*#__PURE__*/React.createElement("small", null, "This form is protected by reCAPTCHA and Google", ' ', /*#__PURE__*/React.createElement(OutboundLink, {
    to: "https://policies.google.com/privacy",
    label: "Privacy Policy"
  }), "\xA0and\xA0", /*#__PURE__*/React.createElement(OutboundLink, {
    to: "https://policies.google.com/terms",
    label: "Terms of Service"
  }), " apply."));
}
export default RecaptchaTermsNotice;